// To Fetch Restaurants near me
export const GET_NEARBY_RESTAURANT = `/api/restaurant/nearby-restaurants`;
// To fetch Restaurant Settings
export const GET_REST_SETTING = `/api/restaurant/v2/details`;
// To fetch restaurant Menu
export const GET_REST_MENU = '/api/pos/menu';
// To get Discount Coupon
export const GET_COUPON = '/api/discount-coupons/v2/get-legacy';

export const VERIFY_TOKEN = '/api/auth/v2/token/customer';
export const SEND_OTP = '/v1/user/send_otp';
export const VERIFY_OTP = '/v1/user/verify_otp';
export const RESEND_OTP = '/v1/user/resend_otp';
export const GET_TOKEN = '/api/auth/v2/customer/login';
export const SIGNUP = '/api/auth/v2/customer/register';
export const GUEST_SIGN_IN = '/api/user/register/guest';
export const REPLACE_GUEST = '/api/user/replace/guest';
export const GET_CART = '/api/v2/orders/cart/get-legacy';
export const ORDER_STATUS = '/api/v2/orders/details';
export const RESTAURANT_DETAILS = '/api/restaurant/v2/details';
export const MQTT_URL = 'wss://mqtt.easyeat.ai:2002/mqtt';
export const CANCEL_ORDER = '/api/v2/orders/cancel';
export const PAYMENT_METHODS = '/api/payment/user-methods';
export const INITIATE_PAYMENT_EP = '/api/v1/payment/initiate';
export const INITIATE_PAYMENT_EP_FC = '/api/v1/payment/initiate/foodcourt';
export const INITIATE_PAYMENT_V3 = '/api/v3/payment/initiate';
export const PAYMENT_STATUS_EP = '/api/v1/payment/check-payment-status';
export const PAYMENT_STATUS_COMMON = '/api/v1/payment/get-payment-detail';
export const PAYMENT_STATUS_END_POINT = '/api/orders/';
export const MALL_RASTAURANT = 'api/food-courts/fc/';
export const GET_MALL_RASTAURANTS = '/api/restaurant/v2/mall-restaurants';
export const CHECK_PREVIOUS_PAYMENT = '/api/v1/payment/check-previous-payment-status';
export const GET_PAYMENT_METHOD = (orderId) => `/api/orders/${orderId}/payments`;
// To Update Cart Item
export const UPDATE_CART_ITEMS = '/api/v2/orders/cart/update';
export const GET_USER_PROFILE = '/api/user/v2/profile';
export const GET_USER_DETAILS = '/api/user/info';
export const QUICK_SERVICES = '/api/restaurant/v2/services';
export const SAVE_USER = '/api/user/v2/profile/update';
export const NUTRITION = '/api/user/v2/nutrition';
export const SAVINGS = '/api/user/v2/savings';
export const ORDERHISTORY = '/api/user/v2/orders';
export const SCHEDULEORDER = '/api/v2/orders/user-schedule';
export const GET_ORDER = '/api/user/v2/order';
export const EMAIL = '/api/user/email-invoice';
export const LOGOUT = '/api/auth/v2/logout';
// Special Note for items
export const UPDATE_CART_NOTE = '/api/v2/orders/cart/notes';
// Update Cart Bill
export const UPDATE_CART_BILL_API = '/api/v2/orders/cart/cart-bill';

export const CLEAR_CART = '/api/orders/cart/clear';
export const GET_MALL_CART = 'api/orders/cart';
export const FOOD_COURT_ORDERS = 'api/orders/food-court-orders';
export const DOWNLOAD_FC_INVOICE = '/api/orders/generate-fc-invoice';
export const EMAIL_INVOICE = 'api/user/email-invoice';
export const DELETE_ALLERGIES = '/api/user/v2/allergies/delete';
export const ALLERGY_FILLTER = '/api/user/v2/allergies/filter';
export const ADD_ALLERGY = '/api/user/v2/allergies';
export const NO_ALLERGY = '/api/user/v2/allergies/update';
export const GET_USER_ADDRESS = '/api/user/v2/address';
export const UPDATE_DISCOUNT_COUPON = '/api/v2/orders/cart/update-discount';
export const COOKING_NOTES = 'api/orders/cart/notes';
export const QUICK_SERVICES_MESSAGE = '/api/messaging/v2/text';
export const ADD_USER_ADDRESS = '/api/user/v2/address/create';
export const GET_DISTANCE_MATRIX = '/api/delivery/v2/distance';
export const CREATE_SCHEDULED_ORDER = '/api/v2/orders/create-schedule';
export const VALIDATE_DELIVERY_SUPPORT = '/api/food-courts/validate-delivery-support';
// SocialMedia connect
export const FACEBOOK_CONNECT = '/api/auth/v2/link/facebook';
export const GOOGLE_CONNECT = '/api/auth/v2/link/google';
export const CREATE_ORDER = '/api/v2/orders/create';
export const SET_DEFAULT_USER_ADDRESS = '/api/user/v2/address/default';
export const SEND_FEEDBACK = '/api/review/v2/create';
export const GET_CREDIT_SCORE = '/api/credit';
export const GET_PROMOTIONS = 'api/promotion/coupons';
// Get Orders by Table -Mergge Bill
export const GET_ORDERS_BY_TABLE = '/api/v2/orders/by-table';
export const GET_ALL_ORDERS = '/api/v2/orders/list';

export const CASH_PAY_ORDER = '/api/messaging/v2/put';
export const CASH_PAY_ORDER_KIOSK = '/api/kiosk/kiosk-offline-order';
export const DIRECT_PAYMENT = '/api/orders/billing/v2/direct-payment';

export const GET_USER_ORDER_LIST = '/api/v2/orders/user-list';

export const REMOVE_UNAVAILABLE_ITEMS = '/api/orders/cart/remove-unavailable-items';
export const REMOVE_FOODCOURT_UNAVAILABLE_ITEMS = '/api/orders/cart/foodcourt/out-of-stock';

export const FCM_SEND_MESSAGE = '/api/fcm/v2/send-message';

export const GET_TABLE_NUMBER = '/api/restaurant/new';
export const GET_LOYALITY_CASHBACK = '/wallet-amount-by-user/';
export const GET_CASHBACK = '/api/rest/wallet/user/restaurant';
export const REDEEM_LOYALTY = '/api/credit/loyalty';
export const CART_LOYALTY = '/api/orders/cart/loyalty';
export const LOYALTY_PROGRAMS = (userId) => `/api/credit/loyalty/programs/${userId}`;
export const LOYALTY_OUTLETS = (userId) => `/api/credit/loyalty/outlets/${userId}`;
export const LOYALTY_TRANSACTIONS = (userId) => `/api/credit/loyalty/transactions/${userId}`;

export const TRACK_ORDER_TYPE = '/api/orders/cart/update-details';
export const MALL_URL = '/api/food-courts/fc/';
export const FC_TRENDING_ITEMS_TOP = '/api/fc-trending-items/top';
export const FC_USER_MENU = (foodcourt) => `/api/food-court-menu/${foodcourt}/user-menu`;

// Referral
export const REFERRAL_CODE = '/api/discount-coupons/referral';
export const REFERRER_CODE = '/api/discount-coupons/referral/referrer-code';
export const REFERRAL_INFO = '/api/discount-coupons/referral/details';
export const OTPLESS_USERDETAILS = '/api/otpless/userdetails';

export const USER_TABLE_CHANGE = 'api/orders/user-table-update';
export const FC_COUPONS = '/api/fc/coupons/active';
export const APPLY_FC_COUPONS = '/api/fc/coupons/apply';
export const REMOVE_FC_COUPONS_REST = '/api/fc/coupons/remove-rest';
export const REMOVE_FC_COUPONS_ALL = '/api/fc/coupons/remove-all';
export const FC_LOYALTY_UPDATE = '/api/food-court-loyalty/update';

// Table reservation Urls
export const GET_TABLE_BOOKINGS = '/api/v1/reservation/user';
export const TR_GET_TIME_SLOTS = '/api/v1/reservation/check-availability';
export const CREATE_RESERVATION = '/api/v1/reservation/create';
export const MODIFY_RESERVATION = '/api/v1/reservation/request-modification';
export const GET_TABLE_BOOKING_BY_ID = '/api/v1/reservation/fetch';
export const CANCEL_RESERVATION = '/api/v1/reservation/request-cancellation';
export const GET_RESERVATION_BY_PAYMENT_ID = '/api/v1/reservation/payment-id';
export const GET_RESERVATION_REFUND_BY_ID = '/api/generic-refunds/reservation-refund-status';

//Check Matching Running Orders
export const GET_MATCHING_ITEMS = 'api/orders/match-running-orders';

// Recommendations
export const GET_BEST_SELLERS = '/api/recommendations/best-sellers';
export const GET_REPEAT_ITEMS = '/api/recommendations/repeat-items';
export const GET_FREQUENTLY_BOUGHT_WITH = '/api/recommendations/frequently-bought-with';
export const GET_COMPLETE_YOUR_CART = '/api/recommendations/complete-your-cart';

export const LHDN_SUBMIT_INDIVIDUAL_DOCUMENTS = 'api/einvoice/submit-individual-documents'
export const LHDN_FETCH_INDIVIDUAL_SUBMISSION_ORDERID ='api/einvoice/fetch-individual-submission-orderid';
export const LHDN_GET_USER_DATA = 'api/einvoice/get-user-data';
export const LHDN_SUBMIT_USER_DATA = 'api/einvoice/submit-user-data';
export const LHDN_FETCH_TAXPAYER_TIN = 'api/einvoice/fetch-taxpayer-tin';